import { actionType } from "../../helpers/reducers";

// DocUsers
export const DOC_USER_SET = "doc_user/SET";
export const DOC_USER_CLEAR = "doc_user/CLEAR";
export const DOC_USER_REMOVE = "doc_user/REMOVE";

export const setDocUser = actionType(DOC_USER_SET);

// API
export const DOC_USER_FETCH = "doc_user/FETCH";
export const DOC_USER_FETCH_ALL = "doc_user/FETCH_ALL";
export const DOC_USER_SAVE = "doc_user/SAVE";
export const DOC_USER_CREATE = "doc_user/CREATE";
export const DOC_USER_DESTROY = "doc_user/DESTROY";

export const fetchDocUser = actionType(DOC_USER_FETCH);
export const fetchDocUsers = actionType(DOC_USER_FETCH_ALL);
export const createDocUser = actionType(DOC_USER_CREATE);
export const saveDocUser = actionType(DOC_USER_SAVE);
export const destroyDocUser = actionType(DOC_USER_DESTROY);
